export const extendedTrial = 'extended-trial'
export const logoutSSO = 'logoutSSO'
